import {
  Box,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  Paper,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { LocalOfferOutlined } from '@material-ui/icons';
import DeleteIcon from '@material-ui/icons/Delete';
import { Alert } from '@material-ui/lab';
import ConfigManagerClient from 'clients/ConfigManagerClient';
import { CustomerClient, getData, getFirst, isValid, isValidWithoutData } from 'clients';
import BotClient from 'clients/BotClient';
import clsx from 'clsx';
import CartPriceFluctuationModal from 'components-v2/mocules/CartPriceFluctuationModal';
import ErrorProductsPayment from 'components-v2/mocules/ErrorProductsPayment';
import ModalListProduct from 'components-v2/mocules/ModalListProduct';
import { ButtonDefault, LinkComp } from 'components/atoms';
import CustomModal from 'components/mocules/CustomModal';
import {
  ARR_REMOVE_PRODUCT,
  BRAND_NAME,
  HTTP_STATUS,
  PAYMENT_METHOD,
  PAYMENT_METHOD_NEED_WAITING,
  TYPE_CUSTOMER_BY_COLOR,
} from 'constants/Enums';
import { ERROR_CODE_CART, ERROR_PRODUCTS } from 'constants/ErrorCart';
import { CART_NEW_GIFT_ICON } from 'constants/Images';
import { CART_URL, TERMS_URL, THANKYOU_URL, WAITING_PAYMENT } from 'constants/Paths';
import { useAuth, useCart, useProduct } from 'context';
import { useModal, useScrollIntoViewOnShow } from 'hooks';
import Cookies from 'js-cookie';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import React, { useMemo, useState } from 'react';
import { CartService } from 'services';
import AddressService from 'services/AddressService';
import { APP_CONFIG_CODE, FEATURE_SHOW_BUTTON_VERIFY_CART, LANG_DEFAULT } from 'sysconfig';
import { FormatNumber, NotifyUtils, gtag } from 'utils';
import { formatCurrency, formatNumber } from 'utils/FormatNumber';
import { ImageFallbackStatic } from 'utils/ImageFallback';
import Insider from 'utils/Insider';
import { useStore } from 'zustand-lib/storeGlobal';
import useMobileV2 from 'zustand-lib/storeMobile';
import useSellers from 'zustand-lib/useSellers';
import CurrencyPopup from '../PaymentMethod/CurrencyPopup';
import VerifyPaymentDiablog from './VerifyPaymentDiablog';
import styles from './styles.module.css';
import validateForm from './validateForm';

// chưa lên popup chan tag 7 ngay
// const isHaveTag7Ngay = (items, dataCustomer) => {
//   if (REGION_MB.indexOf(`${dataCustomer?.provinceCode}`) < 0) {
//     return false;
//   }
//   let result = false;
//   items
//     ?.filter((item) => item.isSelected)
//     .forEach((item) => {
//       const resultItem = item?.productTags?.find((tag) => tag === TAG_HANG_DAT_TRUOC) || false;
//       if (resultItem) result = resultItem;
//     });

//   return result;
// };
const ERROR_REDIRECT_TO_CART = [
  ERROR_CODE_CART.VOUCHER_CODE_INVALID,
  ERROR_CODE_CART.VOUCHER_NOT_MATCH,
  ERROR_CODE_CART.COMBO_INVALID,
  ERROR_CODE_CART.TYPE_INVALID,
  ERROR_CODE_CART.QUANTITY_INVALID,
  ERROR_CODE_CART.SKU_MISSING,
  ERROR_CODE_CART.SKU_NOT_FOUND,
  ERROR_CODE_CART.TOTAL_PRICE_NOT_MATCH,
  ERROR_CODE_CART.LIMIT_SKU,
];

// BE trả message chi tiết cho các lỗi này (ngưỡng giá trị đơn, khu vực, method vừa được đổi sang)
// => hiện nguyên văn message BE thay cho text chung đã map trong i18n.
const DELIVERY_METHOD_DETAIL_ERRORS = [
  ERROR_CODE_CART.DELIVERY_METHOD_NOT_MATCH,
  ERROR_CODE_CART.DELIVERY_METHOD_INVALID,
];
// Lỗi phương thức giao hàng: ở lại checkout và tải lại giỏ để khách thấy method/phí BE vừa chọn lại.
const DELIVERY_METHOD_ERRORS = [
  ...DELIVERY_METHOD_DETAIL_ERRORS,
  ERROR_CODE_CART.DELIVERY_METHOD_NOT_FOUND,
];

// comp thanh toán , sticky
const CheckoutSticky = ({
  data,
  dataCustomer,
  onSetError,
  isMobile,
  onLoading,
  isSaveInfo,
  user,
  invoice,
  invoices = [],
  cart,
  currentAddress,
  deliveryLimitData, // savedInfo,
  translateCheckout,
  paymentMethods,
}) => {
  const { t: translateAlertAction } = useTranslation('alert-action');
  const getCartErrorMessage = (res, fallbackKey = 'message_error_checkout') =>
    (DELIVERY_METHOD_DETAIL_ERRORS.includes(res?.errorCode) && res?.message) ||
    translateAlertAction(`message_error_cart.${res?.errorCode}`) ||
    res?.message ||
    translateAlertAction(fallbackKey);
  const {
    redeemCode = [],
    price = 0,
    totalPrice = 0,
    totalUsdPrice = 0,
    deliveryMethodFee = 0,
    paymentMethodFee = 0,
    totalItemSelected = 0,
    updateCart,
    redeemApplyResult = [],
    cartNo,
    extraFee = null,
    extraFeeNote = null,
    isOverWeightOrVolume,
    cartItems,
    errProducts = [],
    removeCartItem,
    selectCartItem,
    removeImportant,
    paymentMethod,
    getState,
    cartFluctuates = [],
    isOpenPriceFluctuationModal,
    togglePriceFluctuationModal,
    confirmPriceFluctuation,
    applyPriceFluctuationFromVerify,
    // discount = 0,
    // subPrice = 0,
  } = useCart();
  // const redeemRs = redeemApplyResult && redeemApplyResult?.find((item) => !item?.autoApply && item?.canUse === true);
  // const autoRedeemRs = redeemApplyResult && redeemApplyResult?.find((item) => item?.autoApply && item?.canUse === true);

  // multi voucher
  const redeemRs = redeemApplyResult && redeemApplyResult?.filter((item) => !item?.autoApply);
  const autoRedeemRs =
    redeemApplyResult &&
    redeemApplyResult?.filter((item) => item?.autoApply && item?.canUse === true);

  const {
    code,
    discountValue: discountValueManual = 0,
    gifts: giftsManual = null,
  } = redeemRs || {};
  const { discountValue: discountValueAuto = 0, gifts: giftsAuto = null } = autoRedeemRs || {};
  const totalGiftManual =
    (giftsManual?.length > 0 && giftsManual.reduce((a, b) => a + b.quantity, 0)) || 0;
  const totalGiftAuto =
    (giftsAuto?.length > 0 && giftsAuto.reduce((a, b) => a + b.quantity, 0)) || 0;

  const getSellerByCode = useSellers((state) => state.getSellerByCode);
  const getSellerByCodeSync = useSellers((state) => state.getSellerByCodeSync);

  const { handleRedCustomer } = useAuth();
  // TODO: feature-debt
  const debt = useStore((state) => state.getDebt());
  const appConfig = useStore((state) => state.appConfig);
  const setAppConfig = useStore((state) => state.setAppConfig);
  // const availableBalanceFormated = useStore((state) => state.getAvailableDebtBalance({ isFormated: true }));
  const { beta } = useMobileV2();
  const { clearMapProduct } = useProduct();
  // const { user } = useAuth();
  const needToBuy = () => {
    if (extraFee) {
      if (data.customerProvinceCode === '79' || data.customerProvinceCode === '01')
        return 1500000 - price;
      return 2000000 - price;
    }
    return 0;
  };

  // kiem tra loi truoc khi thanh toan
  // const [verifyNotice, setVerifyNotice] = useState(false);

  const locale = Cookies.get('NEXT_LOCALE') || LANG_DEFAULT;
  // doing: chỗ này là togggle popup
  const [showModal] = useModal();
  const router = useRouter();
  const [showConfirmModal, toggleConfirm] = useModal(false);
  const [showMaintenanceModal, setShowMaintenanceModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [checkCondition, setCheckCondition] = useState({
    checked: true,
  });
  const [openCurrencyPopup, setOpenCurrencyPopup] = useState(false);
  const [currencySelected, setCurrencySelected] = useState('');

  const deliveryData =
    dataCustomer.deliveryMethods.find((item) => item.code === dataCustomer.deliveryMethod) || {};
  const deliveryFeeName = useMemo(
    () => (deliveryData ? (deliveryData[`name_${locale}`] ?? deliveryData.name ?? '') : ''),
    [deliveryData, locale],
  );
  const deliveryFeeSubTitle = useMemo(() => deliveryData?.subTitle ?? '', [deliveryData]);

  const paymentData =
    dataCustomer.paymentMethods.find((item) => item.code === dataCustomer.paymentMethod) || {};
  const paymentName = useMemo(
    () => (paymentData ? (paymentData[`name_${locale}`] ?? paymentData.name ?? '') : ''),
    [paymentData, locale],
  );
  const paymentSubTitle = useMemo(
    () => (paymentData ? (paymentData[`subTitle_${locale}`] ?? paymentData.subTitle ?? '') : ''),
    [paymentData, locale],
  );

  const GreenCheckbox = React.memo((props) => (
    <Checkbox classes={{ root: styles.checkbox }} color="default" {...props} />
  ));

  const { district, province, ward } = currentAddress || {};
  let deliveryLimitMessage = '';
  let deliveryLimitCheck = false;

  const handleCheckCondition = (event) => {
    setCheckCondition({ ...checkCondition, [event.target.name]: event.target.checked });
  };

  const GreenCheckBoxElement = (
    <GreenCheckbox
      checked={checkCondition.checked}
      onChange={handleCheckCondition}
      name="checked"
      data-test="checkbox-checkout-terms-of-use"
    />
  );
  const LabelConfirm = (
    <span className={styles.check_agree_txt}>
      {translateCheckout('i_agree_with')}
      <LinkComp href={TERMS_URL} color="#005C29" target>
        &nbsp;{translateCheckout('condition_of_use')}
      </LinkComp>
    </span>
  );

  // const offPayment = user?.settings?.isDisablePayment;

  const validateSubmit = (formData) => {
    try {
      validateForm(formData, onSetError, translateAlertAction);
      return true;
    } catch (error) {
      NotifyUtils.error(error.message);
      return false;
    }
  };
  const handleVerify = async () => {
    onLoading(true);
    const formValue = {
      ...data,
      ...dataCustomer,
      invoice: {
        ...invoice,
        email: data.customerEmail || dataCustomer.customerEmail,
      },
      cartNo,
    };
    Object.keys(formValue).forEach((key) => {
      if (typeof formValue[key] === 'string') formValue[key] = formValue[key].trim();
    });
    if (!validateSubmit(formValue)) {
      onLoading(false);
      return;
    }
    if (!checkCondition.checked) {
      onLoading(false);
      NotifyUtils.error(translateCheckout('message_not_agree_condition_of_use'));
      return;
    }

    // validate provinces

    const districts = await AddressService.getDistrictsByProvince(formValue.customerProvinceCode);
    if (!districts) {
      NotifyUtils.error(translateCheckout('message_not_found_ward_district'));
      onLoading(false);
      return;
    }

    const isExistDistrict = districts.find((item) => item.value === formValue.customerDistrictCode);

    if (!isExistDistrict) {
      NotifyUtils.error(translateCheckout('message_not_found_ward_district'));
      onLoading(false);
      return;
    }
    // Validate
    const dataValidate = {
      ...formValue,
      totalPrice,
      voucherCode: redeemCode[0],
      skus:
        cartItems
          ?.filter((item) => item.isSelected || item.type === 'GIFT')
          ?.map(({ sku, quantity, type }) => ({ sku, type, quantity })) || [],
    };

    const validateRs = await CartService.validateCart({ body: dataValidate });

    NotifyUtils.success(JSON.stringify(validateRs));
    BotClient.sendMesageBotOrderKh({
      message: `Test validate - ${user?.phone || ''} : ${JSON.stringify(validateRs || {})}`,
    });
    onLoading(false);
  };

  const handleSubmit = async () => {
    const formValue = {
      ...data,
      ...dataCustomer,
      invoice: {
        ...invoice,
        email: data.customerEmail || dataCustomer.customerEmail,
      },
      cartNo,
    };
    Object.keys(formValue).forEach((key) => {
      if (typeof formValue[key] === 'string') formValue[key] = formValue[key].trim();
    });

    // validate currency
    if (PAYMENT_METHOD_NEED_WAITING.includes(formValue.paymentMethod)) {
      if (!openCurrencyPopup) {
        setOpenCurrencyPopup(true);
        return;
      }
      if (currencySelected === '') {
        NotifyUtils.error(translateCheckout('message_select_currency'));
        return;
      }

      formValue.currency = currencySelected;
    }

    onLoading(true);
    clearMapProduct();

    if (!validateSubmit(formValue)) {
      onLoading(false);
      return;
    }
    if (!checkCondition.checked) {
      onLoading(false);
      NotifyUtils.error(translateCheckout('message_not_agree_condition_of_use'));
      return;
    }

    // validate provinces
    const districts = await AddressService.getDistrictsByProvince(formValue.customerProvinceCode);
    if (!districts) {
      NotifyUtils.error(translateCheckout('message_not_found_ward_district'));
      onLoading(false);
      return;
    }

    const isExistDistrict = districts.find((item) => item.value === formValue.customerDistrictCode);

    if (!isExistDistrict) {
      NotifyUtils.error(translateCheckout('message_not_found_ward_district'));
      onLoading(false);
      return;
    }
    // Đọc lại giỏ ngay lúc submit: sau khi khách xác nhận biến động giá, closure của hàm
    // này vẫn giữ tổng tiền cũ -> BE trả TOTAL_PRICE_NOT_MATCH.
    const { totalPrice: latestTotalPrice = totalPrice, cartItems: latestCartItems = cartItems } =
      getState() || {};

    // Validate
    const dataValidate = {
      ...formValue,
      totalPrice: latestTotalPrice,
      voucherCode: redeemCode[0],
      skus:
        latestCartItems
          ?.filter((item) => item.isSelected || item.type === 'GIFT')
          ?.map(({ sku, quantity, type }) => ({ sku, type, quantity })) || [],
    };

    const validateRs = await CartService.validateCart({ body: dataValidate });

    /* Gate biến động giá: BE trả kèm fluctuatedItems ngay trong response verify này, nên
       luồng đặt hàng không cần gọi thêm GET /cart/v2 — API có side-effect ghi cache bất đồng
       bộ, đặt sát trước lệnh xoá cart của checkout thì lệnh ghi muộn có thể tái tạo cache đã
       bị xoá => cache có cart, main DB không có.

       Xử lý TRƯỚC nhánh báo lỗi bên dưới vì giá đổi cũng chính là nguyên nhân của
       TOTAL_PRICE_NOT_MATCH. BE chỉ đính fluctuatedItems vào response Ok và
       TOTAL_PRICE_NOT_MATCH, nên các lỗi verify khác vẫn rơi xuống nhánh dưới như cũ. */
    const { fluctuatedItems = [] } = getFirst(validateRs) || {};
    if (applyPriceFluctuationFromVerify(fluctuatedItems)) {
      onLoading(false);
      return;
    }

    if (!isValidWithoutData(validateRs)) {
      // nếu voucher, giỏ hàng lỗi sẽ tự động redirect về giỏ Hàng
      // APO-1559
      if (ERROR_REDIRECT_TO_CART.includes(validateRs?.errorCode)) {
        router.replace(CART_URL);
        NotifyUtils.error(
          translateAlertAction(`message_error_cart.${validateRs?.errorCode}`) ||
            validateRs?.message ||
            translateAlertAction('message_error_checkout'),
        );
        return;
      }
      if (validateRs?.errorCode === TYPE_CUSTOMER_BY_COLOR.LOCKED_CUSTOMER && handleRedCustomer()) {
        return;
      }
      // APO-1559
      // gom những error code về sản phẩm thành 1 thông báo
      if (ERROR_PRODUCTS.includes(validateRs?.errorCode)) {
        NotifyUtils.error(translateAlertAction('message_error_products_cart'));
        onLoading(false);
        await updateCart();
        return;
      }

      if (DELIVERY_METHOD_ERRORS.includes(validateRs?.errorCode)) {
        NotifyUtils.error(getCartErrorMessage(validateRs));
        onLoading(false);
        // DELIVERY_METHOD_NOT_MATCH là luồng bình thường (BE đã tự đổi method), chỉ báo bot khi
        // không có method nào áp dụng được — thường là lỗi config delivery-fee.
        if (validateRs?.errorCode !== ERROR_CODE_CART.DELIVERY_METHOD_NOT_MATCH) {
          BotClient.sendMesageBotOrderKh({
            message: `TS validate error - ${user?.phone || ''}: ${JSON.stringify(validateRs || {})}`,
          });
        }
        await updateCart();
        return;
      }

      if (validateRs?.errorCode === 'ORDER_MIN_1MILION') {
        const getErrorMessage = (errorData) => {
          const defaultMessage = translateAlertAction(`message_error_cart.ORDER_MIN_1MILION`);
          try {
            const { message, messageEN } = errorData.data[0];
            if (locale === 'cam') {
              return message || defaultMessage;
            }
            return messageEN || defaultMessage;
          } catch {
            return defaultMessage;
          }
        };

        NotifyUtils.error(getErrorMessage(validateRs));
      } else {
        NotifyUtils.error(
          translateAlertAction(`message_error_cart.${validateRs?.errorCode}`) ||
            validateRs?.message ||
            translateAlertAction('message_error_checkout'),
        );
      }
      onLoading(false);
      BotClient.sendMesageBotOrderKh({
        message: `TS validate error - ${user?.phone || ''}: ${JSON.stringify(validateRs || {})}`,
      });
      return;
    }

    if (
      invoices &&
      invoices.length < 10 &&
      invoice &&
      invoice.invoiceRequest &&
      invoices.findIndex((item) => item.code === invoice.code) === -1 &&
      invoices.filter(
        ({ taxCode, companyName, companyAddress }) =>
          taxCode === invoice.taxCode &&
          companyName === invoice.companyName &&
          companyAddress === invoice.companyAddress,
      )?.length === 0
    ) {
      await CustomerClient.createInvoiceInfo({ body: invoice });
    }

    const response = await CartService.checkoutCart(formValue);

    if (isValid(response)) {
      // TODO: insider
      Insider.confirmation();
      // FB event tracking purchase
      const dataOrder = getFirst(response);
      if (dataOrder) {
        // fbpixel.purchase({
        //   value: dataOrder.totalPrice,
        //   num_items: dataOrder.totalQuantity,
        // });

        // gtag
        // lọc cartItems được chọn thanh toán
        const GATrackCart = {
          ...cart,
          cartItems: cart?.cartItems?.filter((item) => item.isSelected) || [],
        };
        // load data seller nếu chưa có bằng hàm này
        await Promise.all(
          GATrackCart?.cartItems?.map((prd) => getSellerByCode({ code: prd?.sellerCode })),
        );
        // lấy data seller từ store
        // nếu từ cart / sp là combo thì retailPrice là 1000 -> cần lấy lại giá theo cartItem
        GATrackCart.cartItems =
          GATrackCart?.cartItems?.map((prd) => ({
            ...prd,
            sellerInfo: getSellerByCodeSync({ code: prd?.sellerCode }),
            displayPrice: prd.price,
          })) || [];
        gtag.purchase(GATrackCart);
      }

      if (isSaveInfo) {
        const address = {
          code: formValue.customerAddressCode,
          name: formValue.customerName,
          phone: formValue.customerPhone,
          email: formValue.customerEmail,
          address: formValue.customerShippingAddress,
          provinceCode: formValue.customerProvinceCode,
          districtCode: formValue.customerDistrictCode,
          wardCode: formValue.customerWardCode,
          regionCode: formValue.customerRegionCode,
        };
        if (!formValue.customerAddressCode) {
          const addressResp = await CustomerClient.createAddress({ body: address });
          if (!isValid(addressResp))
            NotifyUtils.error(translateAlertAction('message_failed_save_address'));
        } else {
          const resp = await CustomerClient.updateAddress({ body: address });
          if (isValid(resp)) NotifyUtils.success(translateAlertAction('message_save_address'));
          else if (resp && resp.status === HTTP_STATUS.NotFound) {
            const addressResp = await CustomerClient.createAddress({ body: address });
            if (isValid(addressResp))
              NotifyUtils.success(translateAlertAction('message_save_address'));
            else NotifyUtils.error(translateAlertAction('message_failed_save_address'));
          } else {
            NotifyUtils.error(translateAlertAction('message_failed_save_address'));
          }
        }
      }

      setTimeout(() => {
        updateCart();
      }, 1000);

      // clear products
      // clearMapProduct();
      const { orderId } = response.data[0] || {};

      if (PAYMENT_METHOD_NEED_WAITING.includes(formValue.paymentMethod)) {
        // redirect checkout to waiting payment page
        router.push(`${WAITING_PAYMENT}/${orderId}`);
      } else {
        router.push(`${THANKYOU_URL}/${orderId}`);
      }
    } else {
      if (response?.errorCode === TYPE_CUSTOMER_BY_COLOR.LOCKED_CUSTOMER && handleRedCustomer()) {
        return;
      }
      onLoading(false);
      BotClient.sendMessage({
        message: `TS checkout error - ${user?.phone}: ${JSON.stringify(response || {})}`,
      });

      BotClient.sendMesageBotOrderKh({
        message: `TS checkout error - ${user?.phone}: ${JSON.stringify(response || {})}`,
      });

      NotifyUtils.error(getCartErrorMessage(response));

      setErrorMessage(
        `${translateAlertAction('message__failed_payment')}: ${getCartErrorMessage(
          response,
          'message_system_error',
        )}`,
      );
      updateCart();
    }
  };

  // Feature flag: chặn checkout khi hệ thống đang bảo trì (app config key ALLOW_CHECKOUT)
  // status === 0 => không cho checkout => hiển thị popup bảo trì.
  // status khác 0 (hoặc không tìm thấy config) => cho phép checkout bình thường.
  const getCheckoutBlockedFromConfig = (config = []) => {
    try {
      const item = config?.find((cfg) => cfg?.value?.key === 'ALLOW_CHECKOUT');
      const { status } = item?.value || {};
      return status === 0;
    } catch {
      return false;
    }
  };

  // Lấy trạng thái cờ ALLOW_CHECKOUT mới nhất ngay tại thời điểm bấm checkout.
  // Tránh dùng appConfig đã cache từ SSR (có thể bị stale nếu admin vừa đổi status).
  // Nếu request lỗi => fallback về giá trị đã cache trong store để không chặn nhầm toàn bộ khách.
  const fetchCheckoutBlockedLatest = async () => {
    try {
      const res = await ConfigManagerClient.getAppValueByCode({ appCode: APP_CONFIG_CODE });
      if (isValid(res)) {
        const freshConfig = getData(res) || [];
        setAppConfig(freshConfig);
        return getCheckoutBlockedFromConfig(freshConfig);
      }
    } catch {
      // bỏ qua, fallback bên dưới
    }
    return getCheckoutBlockedFromConfig(appConfig);
  };

  const proceedCheckout = () => {
    if (extraFee) {
      toggleConfirm();
    } else {
      handleSubmit();
    }
  };

  // Bọc hành động checkout: fetch config mới nhất rồi mới quyết định cho qua hay chặn.
  // Gate biến động giá KHÔNG nằm ở đây mà nằm trong handleSubmit, ngay sau validateCart:
  // vừa dùng lại được request verify sẵn có (không phải load lại giỏ), vừa phủ luôn nhánh
  // đi qua modal xác nhận phụ thu (proceedCheckout -> toggleConfirm -> handleSubmit).
  const handleCheckoutClick = async () => {
    onLoading(true);
    const blocked = await fetchCheckoutBlockedLatest();
    onLoading(false);
    if (blocked) {
      setShowMaintenanceModal(true);
      return;
    }
    proceedCheckout();
  };

  // Khách chấp nhận giá mới: chốt giá rồi đặt hàng luôn, không bắt bấm lại nút thanh toán.
  const handleConfirmPriceFluctuation = async () => {
    const result = await confirmPriceFluctuation();
    if (!isValidWithoutData(result)) return;
    togglePriceFluctuationModal(false);
    proceedCheckout();
  };

  const handleBackToCart = () => {
    togglePriceFluctuationModal(false);
    router.push(CART_URL);
  };

  if (deliveryLimitData) {
    deliveryLimitData?.forEach((item) => {
      if (
        item?.wardCodes?.indexOf(ward) >= 0 ||
        item?.districtCodes?.indexOf(district) >= 0 ||
        item?.provinceCodes?.indexOf(province) >= 0
      ) {
        deliveryLimitMessage = item?.message;
        deliveryLimitCheck = true;
      }
    });
  }

  const DisplayPrice = () => (
    <div className={styles.total}>
      {FormatNumber.formatCurrency(Math.max(Math.max(totalPrice, 0), 0))}
    </div>
  );
  const DisplayPriceMobileNew = () => (
    <div className={styles.totalM}>
      <span>{translateCheckout('total_money')}</span>
      <p>{FormatNumber.formatCurrency(Math.max(totalPrice, 0))}</p>
    </div>
  );

  // del err items in cart
  const [openErrItems, toggleErrItems] = useModal();
  // card lỗi nằm dưới cùng cột thanh toán, khách không cuộn xuống sẽ không thấy
  // -> tự cuộn tới khi có sản phẩm lỗi
  const isShowErrCard = errProducts?.length > 0 && !isMobile;
  const errCardRef = useScrollIntoViewOnShow(isShowErrCard);
  const handleDeleteErrProducts = async () => {
    try {
      await errProducts?.forEach(async (item) => {
        if (ARR_REMOVE_PRODUCT.indexOf(item?.errorCode) >= 0) {
          removeCartItem(item);
        }
        if (item?.errorCode === 'MAX_QUANTITY') {
          if (item?.isImportant) {
            await removeImportant(item);
          }
          selectCartItem({
            ...item,
            isSelected: !item.isSelected,
          });
        }
      });
      NotifyUtils.success(translateAlertAction('message_remove_all_error'));
      toggleErrItems();
    } catch (error) {
      NotifyUtils.error(error.message || translateAlertAction('message_remove_all_error_fail'));
    }
    router.reload();
  };

  // translate
  const MapExtraFee = {
    vi: () => (
      <>
        <Typography>
          Với đơn hàng dưới 1.5 triệu đồng (TP HCM và Hà Nội) hoặc dưới 2 triệu đồng (các tỉnh khác)
          sẽ bị phụ phí
          <b> {formatCurrency(50000)}</b>.
        </Typography>
        <Typography>
          Bạn còn cần <b>{formatCurrency(needToBuy())}</b> để được không bị tính phụ phí. Bạn muốn
          tiếp tục chứ?
        </Typography>
      </>
    ),
    // need to translate to English
    en: () => (
      <>
        <Typography>
          Với đơn hàng dưới 1.5 triệu đồng (TP HCM và Hà Nội) hoặc dưới 2 triệu đồng (các tỉnh khác)
          sẽ bị phụ phí
          <b> {formatCurrency(50000)}</b>.
        </Typography>
        <Typography>
          Bạn còn cần <b>{formatCurrency(needToBuy())}</b> để được không bị tính phụ phí. Bạn muốn
          tiếp tục chứ?
        </Typography>
      </>
    ),
    // need to translate to Cambodia
    cam: () => (
      <>
        <Typography>
          Với đơn hàng dưới 1.5 triệu đồng (TP HCM và Hà Nội) hoặc dưới 2 triệu đồng (các tỉnh khác)
          sẽ bị phụ phí
          <b> {formatCurrency(50000)}</b>.
        </Typography>
        <Typography>
          Bạn còn cần <b>{formatCurrency(needToBuy())}</b> để được không bị tính phụ phí. Bạn muốn
          tiếp tục chứ?
        </Typography>
      </>
    ),
  };

  // multi voucher
  const getTotalRedeemRs = (autoRedeem = [], redeem = []) => {
    let total = 0;
    const validDiscounts = {
      auto: autoRedeem?.filter(
        (child) => child.discountValue && typeof +child.discountValue === 'number',
      ),
      redeem: redeem?.filter(
        (child) => child.discountValue && typeof +child.discountValue === 'number',
      ),
    };

    if (validDiscounts.auto && validDiscounts.redeem) {
      total =
        validDiscounts.auto?.reduce((acc, cur) => acc + cur.discountValue, 0) +
        validDiscounts.redeem?.reduce((acc, cur) => acc + cur.discountValue, 0);
    } else {
      // eslint-disable-next-line no-lonely-if
      if (validDiscounts.auto) {
        total = validDiscounts.auto?.reduce((acc, cur) => acc + cur.discountValue, 0);
      } else if (validDiscounts.redeem) {
        total = validDiscounts.redeem?.reduce((acc, cur) => acc + cur.discountValue, 0);
      } else {
        total = 0;
      }
    }
    return formatCurrency(total);
  };

  return (
    <div className={styles.checkout_sticky}>
      <div className={styles.checkout_title}>
        <h1>
          {translateCheckout('order')}{' '}
          <small>
            ({formatNumber(totalItemSelected)} {translateCheckout('product')})
          </small>
        </h1>
        <ButtonDefault
          onClick={() => router.push('/cart')}
          className={styles.btn}
          title={translateCheckout('edit_cart')}
          data-test="btn-checkout-edit"
        >
          {translateCheckout('edit')}
        </ButtonDefault>
      </div>
      <Paper className={styles.root} elevation={4}>
        <div className={styles.d_flex}>
          <div className={styles.checkout_label}>{translateCheckout('estimated_total')}</div>
          <div className={styles.checkout_content}>{formatCurrency(price)}</div>
        </div>
        {/* // TODO: feature-debt */}
        {debt?.isActive && (
          <div className={styles.d_flex}>
            <div className={styles.checkout_label}>{translateCheckout('debt_remain')}</div>
            <div className={styles.checkout_content}>{debt.balanceFormated}</div>
          </div>
        )}
        <div className={styles.d_flex}>
          <div className={styles.checkout_label}>
            <div className={styles.checkout_label_first}>
              {deliveryFeeName || translateCheckout('delivery_fee')}
            </div>
            {deliveryFeeSubTitle && (
              <div className={styles.checkout_label_second}>{deliveryFeeSubTitle}</div>
            )}
          </div>
          <div className={styles.checkout_content}>{formatCurrency(deliveryMethodFee)}</div>
        </div>
        <div className={styles.d_flex}>
          <div className={styles.checkout_label}>
            <div className={styles.checkout_label_first}>
              {paymentName || translateCheckout('checkout_fee')}
            </div>
            {paymentSubTitle && (
              <div className={styles.checkout_label_second}>{paymentSubTitle}</div>
            )}
          </div>
          <div className={styles.checkout_content}>
            {paymentData?.code !== PAYMENT_METHOD.CREDIT && formatCurrency(paymentMethodFee)}
          </div>
        </div>

        {extraFee && (
          <div className={styles.d_flex}>
            <div className={styles.checkout_label}>
              <div className={styles.checkout_label_first}>{translateCheckout('surcharge')}</div>
              {extraFeeNote && <div className={styles.checkout_label_second}>{extraFeeNote}</div>}
            </div>
            <div className={styles.checkout_content}>{formatCurrency(extraFee)}</div>
          </div>
        )}
        {/* filter() luôn trả mảng mà [] là truthy, nên điều kiện cũ đúng cả khi giỏ
            không có mã nào -> hiện "-0". Phải kiểm độ dài. */}
        {(redeemRs?.length > 0 || autoRedeemRs?.length > 0) && (
          <div>
            <Divider className={styles.dividerCustom} />
            <div className={`${styles.total_redeems}  ${styles.d_flex}`}>
              <Typography className={styles.checkout_label}>
                {translateCheckout('total_discount')}
              </Typography>
              <div
                className={styles.checkout_content}
              >{`-${getTotalRedeemRs(autoRedeemRs, redeemRs)}`}
              </div>
            </div>
            {/* autoRedeemRs là mảng (filter), destructure nó như object ở trên cho
                discountValueAuto = 0 nên hai map cũ không bao giờ chạy, mã auto không
                hiện tên. Map thẳng mảng, đúng cách khối mã thủ công bên dưới đang làm. */}
            {autoRedeemRs?.length > 0 &&
              autoRedeemRs.map((child, index) => (
                <div
                  key={child?.code || index}
                  className={clsx(styles.d_flex, styles.checkout_promo_code)}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <LocalOfferOutlined fontSize="small" />
                    <span
                      style={{
                        color: '#A2A0A0',
                        marginLeft: '4px',
                        fontSize: '14px',
                        maxWidth: '70%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {child?.code}
                    </span>
                  </div>
                  {child?.discountValue > 0 && (
                    <div
                      className={clsx(styles.checkout_content, styles.break_line)}
                    >{`-${formatCurrency(child.discountValue)}`}
                    </div>
                  )}
                  {child?.gifts?.length > 0 && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Typography style={{ fontFamily: 'ggsm', marginRight: 5, color: '#000' }}>
                        x
                        {child.gifts
                          ?.flat()
                          ?.reduce(
                            (accmulator, currentChild) => accmulator + currentChild?.quantity,
                            0,
                          ) || 0}
                      </Typography>
                      <ImageFallbackStatic
                        src={CART_NEW_GIFT_ICON}
                        alt="icon gift"
                        height="19"
                        width="19"
                      />
                    </div>
                  )}
                </div>
              ))}
            {redeemRs &&
              redeemRs.length > 0 &&
              redeemRs.map((child, index) => (
                <div
                  key={child.code || index}
                  className={clsx(styles.d_flex, styles.checkout_promo_code)}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <LocalOfferOutlined fontSize="small" />
                    <span
                      style={{
                        color: '#A2A0A0',
                        marginLeft: '4px',
                        fontSize: '14px',
                        maxWidth: '70%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {child.code}
                    </span>
                  </div>
                  {child.discountValue > 0 && (
                    <div
                      className={clsx(styles.checkout_content, styles.break_line)}
                    >{`-${formatCurrency(child.discountValue)}`}
                    </div>
                  )}
                  {child.gifts?.length > 0 && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Typography style={{ fontFamily: 'ggsm', marginRight: 5, color: '#000' }}>
                        x
                        {child.gifts
                          ?.flat()
                          ?.reduce(
                            (accmulator, currentChild) => accmulator + currentChild?.quantity,
                            0,
                          ) || 0}
                      </Typography>
                      <ImageFallbackStatic
                        src={CART_NEW_GIFT_ICON}
                        alt="icon gift"
                        height="19"
                        width="19"
                      />
                    </div>
                  )}
                </div>
              ))}
          </div>
        )}
        {/* {(redeemRs || autoRedeemRs) && (
          <div>
            <Divider style={{ margin: 'auto', width: '90%' }} />
            <Typography style={{ padding: '8px 16px', fontFamily: 'ggsm', fontSize: 14 }}>{translateCheckout('deal')}</Typography>
            {autoRedeemRs && (
              <div className={styles.d_flex} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography style={{ color: '#000', fontSize: '14px' }}>{translateCheckout('auto_apply')}</Typography>
                {discountValueAuto > 0 && <Typography className={styles.checkout_content}>-{formatCurrency(discountValueAuto)}</Typography>}
                {giftsAuto?.length > 0 && (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography style={{ fontFamily: 'ggsm', marginRight: 5, color: '#000' }}>x{totalGiftAuto}</Typography>
                    <ImageFallbackStatic src={GIFT_ICON2} alt="icon gift" height="19" width="19" />
                  </div>
                )}
              </div>
            )}
            {redeemRs && (
              <div className={clsx(styles.d_flex, styles.checkout_promo_code)}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <LocalOfferOutlined fontSize="small" />
                  <span style={{ color: '#000', marginLeft: '4px', fontSize: '14px' }}>
                    {translateCheckout('code')} {code}
                  </span>
                </div>
                {discountValueManual > 0 && <div className={styles.checkout_content}>{`-${formatCurrency(discountValueManual)}`}</div>}
                {giftsManual?.length > 0 && (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography style={{ fontFamily: 'ggsm', marginRight: 5, color: '#000' }}>x{totalGiftManual}</Typography>
                    <ImageFallbackStatic src={GIFT_ICON2} alt="icon gift" height="19" width="19" />
                  </div>
                )}
              </div>
            )}
          </div>
        )} */}
        <Divider style={{ margin: 'auto', width: '90%' }} />

        <div style={{ margin: '12px 0' }} className={styles.d_flex}>
          <div className={styles.checkout_label} style={{ fontSize: 16 }}>
            {translateCheckout('total_money')}
          </div>
          <div className={styles.total}>{formatCurrency(Math.max(0, totalPrice))}</div>
        </div>
        {totalUsdPrice > 0 && (
          <div style={{ margin: '12px 0' }} className={styles.d_flex}>
            <div className={styles.checkout_label} style={{ fontSize: 16 }}>
              USD
            </div>
            <div className={styles.total}>{formatCurrency(totalUsdPrice, ',', '$')}</div>
          </div>
        )}
        <Divider style={{ margin: 'auto', width: '90%' }} />

        <div>
          <p style={{ padding: '8px 16px', color: '#000' }}>
            {translateCheckout('check_info_alert')}
          </p>

          <div className={styles.condition}>
            <FormControlLabel
              style={{ padding: '8px 16px' }}
              control={GreenCheckBoxElement}
              label={LabelConfirm}
            />
            <div className={styles.list_note}>
              <p>1. {translateCheckout('alert_cancel').replace('{BRAND_NAME}', BRAND_NAME)}</p>
              <p>2. {translateCheckout('alert_wrong_quantity')}</p>
            </div>
          </div>
        </div>
        {!isMobile && (
          <div style={{ padding: '0 16px', color: '#000' }}>
            <Tooltip title={checkCondition.checked && translateCheckout('agree_with_condition')}>
              <ButtonDefault
                disabled={
                  !checkCondition.checked ||
                  deliveryLimitCheck ||
                  isOverWeightOrVolume ||
                  (debt && debt.debtBalance <= 0)
                }
                className={clsx('payment_button', styles.continue_btn)}
                onClick={handleCheckoutClick}
                data-test="btn-checkout-payment"
              >
                {translateCheckout('checkout')}
              </ButtonDefault>
            </Tooltip>
          </div>
        )}
      </Paper>

      <div className={styles.text_right}>
        {/* {userAuth?.settings?.isDisplayNotiTopBar && (
          <div className={styles.condition}>
            <Alert severity="error" style={{ marginTop: '10px', borderRadius: '8px' }}>
              {userAuth?.settings?.content}
            </Alert>
          </div>
        )} */}
        <VerifyPaymentDiablog visible={showModal} />
        {errorMessage && (
          <div className={styles.condition}>
            <Alert severity="error" style={{ marginTop: '10px', borderRadius: '8px' }}>
              {errorMessage}
            </Alert>
          </div>
        )}
        {deliveryLimitMessage && (
          <div className={styles.condition}>
            <Alert severity="error" style={{ marginTop: '10px', borderRadius: '8px' }}>
              {deliveryLimitMessage}
            </Alert>
          </div>
        )}

        {/* // TODO: feature-debt */}
        {debt?.balance <= 0 && (
          <div className={styles.condition}>
            <Alert severity="error" style={{ marginTop: '10px', borderRadius: '8px' }}>
              {debt?.balanceMessageError}
            </Alert>
          </div>
        )}

        {FEATURE_SHOW_BUTTON_VERIFY_CART && (
          <ButtonDefault btnType="success" className={styles.checkout_btn} onClick={handleVerify}>
            {translateCheckout('check')}
          </ButtonDefault>
        )}

        {isMobile && (
          <div
            className={clsx(
              styles.sticky_checkout_bar_mobile,
              beta && styles.sticky_checkout_bar_mobileNew,
            )}
          >
            <div className={styles.fwc_container}>
              <div className={styles.flex_price}>
                {beta ? <DisplayPriceMobileNew /> : <DisplayPrice />}
              </div>
              <div>
                {/* /// TODO: feature-debt */}
                <ButtonDefault
                  disabled={
                    !checkCondition.checked ||
                    user.isQuest ||
                    deliveryLimitCheck ||
                    isOverWeightOrVolume ||
                    (debt && debt.balance <= 0)
                  }
                  btnType={beta ? 'primary' : 'warning'}
                  onClick={handleCheckoutClick}
                  classes={{
                    label: styles.label,
                    outlined: styles.outlined,
                    root: beta ? styles.mobileRoot_btn : styles.root_btn,
                  }}
                >
                  {translateCheckout('checkout')}
                </ButtonDefault>
              </div>
            </div>
          </div>
        )}
      </div>
      {isShowErrCard && (
        <div className={styles.card_err_container} ref={errCardRef}>
          <Typography className={styles.text_err_notification}>
            {translateCheckout('message_error_products_in_cart')}
            <b className={styles.delete_text} role="presentation" onClick={toggleErrItems}>
              <DeleteIcon fontSize="small" /> {translateCheckout('click_here_to_delete')}
            </b>
          </Typography>
          <ErrorProductsPayment />
        </div>
      )}
      {openErrItems && (
        <ModalListProduct
          products={errProducts}
          isShowPopupConfirm={openErrItems}
          handleClosePopup={toggleErrItems}
          handleClick={handleDeleteErrProducts}
          title={translateCheckout('confirmation')}
          content={
            // eslint-disable-next-line react/jsx-wrap-multilines
            <>
              <Typography
                className={styles.text_content_modal}
                style={{ fontWeight: '700', marginTop: '15px' }}
              >
                {translateCheckout('message_delete_all_error_products')}
              </Typography>
              <Typography className={styles.text_content_modal} style={{ marginTop: '20px' }}>
                {translateCheckout('message_exceed_back')}
              </Typography>
            </>
          }
        />
      )}
      <CustomModal
        visible={showConfirmModal}
        onClose={toggleConfirm}
        title={translateCheckout('confirmation')}
        btnOk={translateCheckout('confirm')}
        onClickOk={handleSubmit}
        btnOnClose={translateCheckout('check_cart')}
      >
        {extraFee && MapExtraFee[LANG_DEFAULT]()}
        {/* {isHaveTag7Ngay(cartItems, user) && (
          <>
            <Typography>Đơn hàng có sản phẩm Đặt trước 7 ngày. Bạn chắc chắn muốn xác nhận thanh toán cho đơn hàng này?</Typography>
          </>
        )} */}
      </CustomModal>

      <CartPriceFluctuationModal
        visible={isOpenPriceFluctuationModal}
        onClose={() => togglePriceFluctuationModal(false)}
        onBack={handleBackToCart}
        onConfirm={handleConfirmPriceFluctuation}
        products={cartFluctuates}
        isMobile={isMobile}
        isFromCheckout
      />

      {/* Popup bảo trì: hiện khi cờ ALLOW_CHECKOUT đang bật chặn thanh toán */}
      {showMaintenanceModal && (
        <CustomModal
          visible={showMaintenanceModal}
          onClose={() => setShowMaintenanceModal(false)}
          icon={false}
          title={translateCheckout('maintenance_title')}
          content={translateCheckout('maintenance_message')}
          btnOkRender={false}
          btnCloseRender={false}
          customBtnRender={
            // eslint-disable-next-line react/jsx-wrap-multilines
            <div style={{ textAlign: 'center' }}>
              <ButtonDefault
                btnType="primary"
                className={styles.checkout_btn}
                onClick={() => setShowMaintenanceModal(false)}
              >
                {translateCheckout('maintenance_understand')}
              </ButtonDefault>
            </div>
          }
        >
          <Box display="flex" justifyContent="center" my={2}>
            <CircularProgress size={48} thickness={4} style={{ color: '#005C29' }} />
          </Box>
        </CustomModal>
      )}
      {openCurrencyPopup && (
        <CurrencyPopup
          paymentMethod={paymentMethods?.find((item) => item.code === dataCustomer.paymentMethod)}
          cartTotalPrice={totalPrice}
          cartTotalUsdPrice={totalUsdPrice}
          open={openCurrencyPopup}
          currencySelected={currencySelected}
          setCurrencySelected={setCurrencySelected}
          onClose={() => {
            setCurrencySelected('');
            setOpenCurrencyPopup(false);
          }}
          handleSubmit={handleSubmit}
        />
      )}
    </div>
  );
};

export default CheckoutSticky;
